// laneCourse — map a cookpit lane code to its course word.
//
// Lanes encode a course plus an index: A0 (the global alarm lane), S1–S3
// (starter), M1–M3 (main), D1–D3 (dessert). CookChow surfaces only the
// course word — "Alert" for the alarm lane, "Starter" / "Main" / "Dessert"
// for the course lanes — dropping the numeric index entirely. The raw code
// is the fallback for anything unexpected.
//
// Single source of truth shared by the web lane chips (`laneLabel`) and the
// function's computed-hotspot text, so user-facing copy never leaks a raw
// lane code (e.g. "M1"). Display only: lane-keyed logic (classifier, tick
// ordering, deterministic ids) keeps using the original codes.

export function laneCourse(lane: string): string {
  // Total by construction: a non-string or empty lane yields '' rather than
  // throwing, so a malformed/absent lane can never crash the projection that
  // builds computed-hotspot copy.
  if (typeof lane !== 'string' || lane.length === 0) return '';
  switch (lane[0]!.toUpperCase()) {
    case 'A':
      return 'Alert';
    case 'S':
      return 'Starter';
    case 'M':
      return 'Main';
    case 'D':
      return 'Dessert';
    default:
      return lane;
  }
}
